import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from "../authentication/authentication.service";

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,private auth: AuthenticationService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (localStorage.getItem('token')) {
      // logged in so return true
      return true;
    }
    //console.log('token not found 2');
    // not logged in so redirect to login page
    this.auth.logout();
    this.router.navigate(['/auth/signin']);
    return false;
  }

}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/guards/auth.guard.ts